export const buildInfo = {
  "timestamp": "2026-10-12T17:49:47.870Z",
  "version": "0.0.0",
  "gitHash": "309f346"
};
